export const RADIAN_EVENTS = [
    {code: '030', label: 'Acuse de recibo'},
    {code: '032', label: 'Recibo del bien/servicio'},
    {code: '033', label: 'Aceptación expresa'}
];

/**
 * Posición del código dentro de la secuencia RADIAN. -1 si no aplica (00/null/031).
 */
export function eventRank(code) {
    return RADIAN_EVENTS.findIndex(event => event.code === code);
}

/**
 * Evento de mayor rango marcado en un array de códigos seleccionados.
 */
export function highestChecked(eventsChecked) {
    return RADIAN_EVENTS
        .filter(event => eventsChecked.includes(event.code))
        .map(event => event.code)
        .pop() || null;
}

/**
 * Para cada evento, indica si TODOS los documentos ya lo tienen emitido (D-01).
 */
export function commonEmittedEvents(documents) {
    return RADIAN_EVENTS.reduce((acc, event) => {
        acc[event.code] = documents.length > 0 && documents.every(doc =>
            eventRank(doc.status_dian_code) >= eventRank(event.code) && doc.status_dian_code !== '031'
        );
        return acc;
    }, {});
}

/**
 * Cuántos de los documentos seleccionados ya alcanzaron el evento dado.
 */
export function partialSummary(documents, eventCode) {
    const count = documents.filter(doc =>
        eventRank(doc.status_dian_code) >= eventRank(eventCode) && doc.status_dian_code !== '031'
    ).length;

    return {count, total: documents.length};
}

/**
 * Aplica la cascada hacia abajo (RF-02/D-02): al desmarcar un evento, se desmarcan los superiores.
 */
export function cascadeUncheck(newChecked) {
    const firstGapIndex = RADIAN_EVENTS.findIndex(event => !newChecked.includes(event.code));

    if (firstGapIndex === -1) {
        return newChecked;
    }

    const allowedCodes = RADIAN_EVENTS.slice(0, firstGapIndex).map(event => event.code);
    return newChecked.filter(code => allowedCodes.includes(code));
}

const STATUS_LABELS = {
    '030': 'Acuse de recibo',
    '032': 'Recibo bien/servicio',
    '033': 'Aceptación expresa',
    '031': 'Reclamado/Rechazado'
};

/**
 * Etiqueta fija de estado para la columna "Estado" del listado (D-05).
 */
export function statusDianLabel(code) {
    return STATUS_LABELS[code] || 'Sin eventos';
}



// WEBPACK FOOTER //
// ./src/modules/reception_documents/radian_events.js